module.exports = __webpack_public_path__ + "img/adimg1.f84d6a4a.png";